import React from 'react';
import { motion } from 'framer-motion';
import './Profiles.css';
import { FaGithub } from 'react-icons/fa';
import { SiLeetcode, SiCodeforces, SiCodechef } from 'react-icons/si';
import { SiGeeksforgeeks } from 'react-icons/si';

const Profiles = () => {
  const profiles = [
  {
    name: 'GitHub',
    icon: <FaGithub />,
    url: 'https://github.com/shristi76',
    color: 'white'
  },
  {
    name: 'LeetCode',
    icon: <SiLeetcode />,
    url: 'https://leetcode.com/u/shristi__/',
    color: '#FFA116'
  },

  {
    name: 'CodeChef',
    icon: <SiCodechef />,
    url: 'https://www.codechef.com/users/shristi55',
    color: 'red'
  }
,
//   {
//   name: 'GeeksforGeeks',
//   icon: <SiGeeksforgeeks />,
//   url: 'https://www.geeksforgeeks.org/profile/shrist1jq8',
//   color: '#2F8D46'
// }

  // {
  //   name: 'Codeforces',
  //   icon: <SiCodeforces />,
  //   url: 'https://codeforces.com/profile/riseXcoder',
  //   color: '#1F8ACB'
  // },


  ];

  return (
    <section id="profiles" className="profiles">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Coding Profiles</h2>
          <div className="underline"></div>
        </motion.div>

        <motion.div
          className="profiles-grid"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          {profiles.map((profile, index) => (
            <motion.a
              key={profile.name}
              href={profile.url}
              target="_blank"
              rel="noopener noreferrer"
              className="profile-card"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, y: -5 }}
              whileTap={{ scale: 0.95 }}
            >
              <div className="profile-icon" style={{ color: profile.color }}>
                {profile.icon}
              </div>
              <h3>{profile.name}</h3>
            </motion.a>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Profiles;